import React from 'react';
import Statistics from './Statistics';

const MonthlyReports = () => {
  return <Statistics tab="monthly" />;
};

export default MonthlyReports;
